import React from 'react'
import { Text, View } from '../components/Themed';
import { StyleSheet, TextInput } from 'react-native';
import { Button } from 'react-native-elements';
import emailjs from 'emailjs-com';
import{ init } from 'emailjs-com';

function Email({ code }) {
    const MAX_EMAILS : number = 3;

    var emailJsUserId = "user_87iYh52lnwHTDjb1vACtI";
    init(emailJsUserId);

    const [Email, setEmail] = React.useState("");
    const [Sending, setSending] = React.useState(false);
    const [EmailsSent, setEmailsSent] = React.useState(0);

    function sendEmail(email: string) {
        if (!isEmailValid(email)) {
            alert("Format d'adresse courriel incorrect.");
            return;
        }

        if (EmailsSent >= MAX_EMAILS) {
            alert("Vous avez envoyé trop de courriels pour cet Avatar.");
            return;
        }

        console.log(`sending ${code} to ${email}`);
        setSending(true);

        // Wait for a timeout in case something bad happens
        setTimeout(() => {
            setSending(false);
        }, 10000);

        emailjs.send("gmail","code",{
            code: code,
            to_email: email,
        })
        .then((result) => {
            console.log(result.status + ": " + result.text);
            setEmailsSent(EmailsSent + 1);
            if (result.status == 200) {
                alert(`Code ${code} envoyé avec succès à ${email}.`);
            }
            setSending(false);
        }, (error) => {
            alert("Une erreur s'est produite, le courriel n'a pu être envoyé.");
            console.log(error.text);
            setSending(false);
        });
    }

    function isEmailValid(email: string) {
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return regex.test(email);
    }

    return (
        <>
            <Text style={styles.text}>
                Vous ne voulez pas perdre le code? Nous pouvons vous l'envoyer par courriel.
            </Text>
            <Text style={styles.text}>
                Don't want to lose your code? We can send it to you by email.
            </Text>
            <View style={styles.emailContainer}>
                <TextInput
                    style={styles.inputField}
                    editable
                    placeholder="Votre adresse courriel \ Your email address"
                    onChangeText={text => setEmail(text)}
                    onSubmitEditing={() => sendEmail(Email)}
                />
                <Button
                    title="Envoyer / Send"
                    onPress={() => sendEmail(Email)}
                    loading={Sending}
                    disabled={Sending}
                />
            </View>
        </>
    )
}

const styles = StyleSheet.create({
    emailContainer:{
        flex: 1,
        flexDirection: 'row',
        width: "100%",
        marginHorizontal: 15
    },
    text: {
        fontSize: 17,
        lineHeight: 24,
        margin: 10,
        color: 'rgba(0,0,0,0.8)'
    },
    inputField: {
        height: 45,
        width: "100%",
        fontSize: 16,
        borderRadius: 5,
        paddingLeft: 15,
        border: "1px solid #ccc",
        borderBottomWidth: 2,
        transition: "all 0.3s ease",
        marginRight: 15
    }
});

export default Email
